import { AnalyticEventType } from "./AnalyticEventType";
import { BaseAnalyticEvent } from "./BaseAnalyticEvent";

export class VirtualScreenEvent extends BaseAnalyticEvent {
    public readonly screenName: string;
    public readonly screenIndex: number;
    public readonly loadTime: number;
    public readonly indication: number;

    public constructor(
        screenName: string,
        screenIndex: number,
        loadTime?: number,
        indication?: number
    ) {
        super(AnalyticEventType.VirtualScreenView);
        this.screenName = screenName;
        this.screenIndex = screenIndex;
        this.loadTime = loadTime;
        this.indication = indication;
    }
}
